import AboutMe from "../AboutMe";
import HeroSection from "../HeroSection";
import MyPortfolio from "../MyPortfolio";
import MySkills from "../MySkills";
import Footer from "../Footer";

export default function Home() {
  return (
    <>
      <HeroSection />
      <MyPortfolio />
      <MySkills />
      <AboutMe />
      <Footer />
      
    </>
  );
}
